<template>
  <div class="dep-full-map" v-loading="loading">
      <yandex-map
        v-if="coords"
        :coords="coords"
        :zoom="zoom"
        style="width: 100%; height: 400px;"
        :controls="controls"
        @map-was-initialized="loading = false">
        <ymap-marker
                marker-id="1"
                marker-type="placemark"
                :coords="coords">
        </ymap-marker>
      </yandex-map>
      <div v-if="!loading" class="dep-full-map__hide-button hidden-xs" @click="hide">
        <img src="static/img/icon_map-hide.svg" :alt="$t('labels.collapse')">
        {{ $t('labels.collapse') }}
      </div>
  </div>
</template>
<script>
  export default {
    props: [
      'geodata'
    ],
    data () {
      return {
        loading: true,
        coords: '',
        zoom: 17,
        controls: ['fullscreenControl', 'geolocationControl', 'zoomControl']
      }
    },
    methods: {
      hide () {
        this.$emit('hideFullMap')
      },
      setCoords () {
        if (this.geodata) {
          this.coords = this.geodata
        }
      }
    },
    mounted () {
      this.setCoords()
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.dep-full-map {
  position: relative;
  height: 400px;
  width: 100%;
  margin-bottom: 20px;
  overflow: hidden;
  background: #fff;

  &__hide-button {
    position: absolute;
    top: 10px;
    right: 50px;
    padding: 5px 10px;
    background: #fff;
    border-radius: $global-radius;
    cursor: pointer;

    img {
      margin-right: 5px;
    }
  }
}
</style>